import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import type { Range } from '@attain-apps/range'

/**
 * A pipe that formats a range of dates into a human-readable string.
 * If the start or end dates are missing, default placeholders are shown.
 *
 * Example:
 *   Input: { start: new Date('2024-01-01'), end: new Date('2024-01-10') }
 *   Output: "1/1/2024 - 1/10/2024"
 */
@ngCore.Pipe({
  name: 'formattedDateRange',
  standalone: true,
})
export class FormattedDateRangePipe implements ngCore.PipeTransform {
  /**
   * Transforms a date range into a formatted string.
   * Falls back to default placeholders when start or end dates are missing.
   */
  public transform(value: Range<Date>): string {
    const { start, end } = value

    const formattedStart = _formatDate(start) ?? 'BOT'
    const formattedEnd = _formatDate(end) ?? 'EOT'

    return `${formattedStart} - ${formattedEnd}`
  }
}

/**
 * Formats a single date using the shared date-only display format.
 */
function _formatDate(date?: Date): string | undefined {
  return ents.core.display.date.format(date)
}
